import {TimeSlot} from "../../types";

export async function postReservation(booking:Booking) {
    console.log('post-reservation.ts')
    const reactAppData = window.react_data.api_url ? window.react_data : {api_url:'http://localhost:8000/api/v1/'};
    const endPoint = 'reserve';

    let data = new FormData();
    data.append('action', 'react_data');

    switch (booking.booking_flow) {
        case 'hjulskifte':
            data.append('spot', booking.hjulskifte.spot_id);
            break;
        case 'hjulskifte-arval':
            data.append('spot', booking.hjulskifte.spot_id);
            break;
        case 'window':
            data.append('spot', booking.window.spot_id);
            break;
    }

    data.append('type', booking.booking_flow);
    data.append('session', booking.session.toString());

    return await fetch(reactAppData.api_url+endPoint, {body:data, method:'post'})
        .then(res => res.json())
        .then(
            (result) => {
                console.log(result)
                return result
            },
            (error) => {
                return {error:error}
            }
        );
}



export async function checkSpotsAvailability(spots:TimeSlot[], booking:Booking) {

    console.log('post-reservation.ts')
    const reactAppData = window.react_data.api_url ? window.react_data : {api_url:'http://localhost:8000/api/v1/'};
    const endPoint = 'confirm';

    let data = new FormData();
    data.append('spots', JSON.stringify(spots));
    data.append('type', booking.booking_flow);
    data.append('session', booking.session.toString());

    return await fetch(reactAppData.api_url+endPoint, {body:data, method:'post'})
        .then(res => res.json())
        .then(
            (result) => {
                return result
            },
            (error) => {
                return []
            }
        );
}
